import { cn } from "@/lib/utils";

const base = "inline-flex items-center gap-1 rounded-[4px] border px-1.5 py-0.5 text-[10px] font-bold uppercase tracking-wider whitespace-nowrap";

const MOVEMENT = {
  Fast: ["▲ Fast", "bg-emerald-50 text-emerald-700 border-emerald-200"],
  Medium: ["► Medium", "bg-blue-50 text-blue-700 border-blue-200"],
  Slow: ["▼ Slow", "bg-amber-50 text-amber-800 border-amber-200"],
};

const POSITION = {
  "Low Bought": ["▼ Low Bought", "bg-red-50 text-red-700 border-red-300 pulse-low"],
  Balanced: ["● Balanced", "bg-emerald-50 text-emerald-700 border-emerald-200"],
  "Over Bought": ["▲ Over Bought", "bg-indigo-50 text-indigo-700 border-indigo-200"],
  "No Stock / No Sale": ["– No Stock / Sale", "bg-slate-100 text-slate-500 border-slate-200"],
};

const STATUS = {
  pending: "bg-amber-50 text-amber-800 border-amber-200",
  partial: "bg-sky-50 text-sky-700 border-sky-200",
  dispatched: "bg-emerald-50 text-emerald-700 border-emerald-200",
  received: "bg-emerald-50 text-emerald-700 border-emerald-200",
  closed: "bg-violet-50 text-violet-700 border-violet-200",
  active: "bg-emerald-50 text-emerald-700 border-emerald-200",
  cancelled: "bg-slate-100 text-slate-500 border-slate-200",
};

export const MovementBadge = ({ value }) => {
  const [label, cls] = MOVEMENT[value] || [value, ""];
  return <span className={cn(base, cls)}>{label}</span>;
};

export const PositionBadge = ({ value, cover }) => {
  const [label, cls] = POSITION[value] || [value, ""];
  const extra = cover == null ? (value === "Over Bought" ? " (no sales)" : "") : ` ${cover} mo`;
  return <span className={cn(base, cls)}>{label}{extra}</span>;
};

export const WarehouseBadge = ({ value }) => (
  <span className={cn(base, value === "A" ? "bg-blue-50 text-blue-700 border-blue-200" : "bg-violet-50 text-violet-700 border-violet-200")}>
    WH {value}
  </span>
);

const LABEL = { closed: "closed (short)" };
export const StatusBadge = ({ value }) => <span className={cn(base, STATUS[value])} data-testid={`status-${value}`}>{LABEL[value] || value}</span>;

export const TypeBadge = ({ value }) => (
  <span className={cn(base, value === "IN" ? "bg-emerald-50 text-emerald-700 border-emerald-200" : "bg-red-50 text-red-700 border-red-200")}>
    {value === "IN" ? "↓ IN" : "↑ OUT"}
  </span>
);
